// extracted by mini-css-extract-plugin
module.exports = {"loader":"IconSuccess_loader__-hcRc","root":"IconSuccess_root__1hTQO","fillColor":"IconSuccess_fillColor__1euA9"};